import axios from "axios";
import * as d3 from "d3";
import {
    axisTextDim1,
    colonAnnotation,
    format,
    fw_progressive_1way,
    fw_progressive_3way,
    inrFormatter,
    make_y_gridlines,
    numberFormat,
    responsivefy,
    XaxisAttribute
} from '../functions'

export default function (chart, divId, vizName, filterParam, gridflag) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    //var tempVar = chart.tempVar
    var axisLabelFontSize = (chart.axisLabelFontSize - 9) + "px"

    console.warn("Filter param in chart function", filterParam)

    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    function DataSegregator(array, on) {
        let OrdinalPositionHolder;
        OrdinalPositionHolder = {
            valueOf: function () {
                let thisObject;
                thisObject = this
                var keys = Object.keys(thisObject)
                keys.splice(keys.indexOf('valueOf'), 1)
                keys.splice(keys.indexOf('keys'), 1)
                return keys.length === 0 ? -1 : d3.max(keys, function (d) {
                    return thisObject[d]
                })
            },
            keys: function () {
                let thisObject;
                thisObject = this
                var keys = Object.keys(thisObject)
                keys.splice(keys.indexOf('valueOf'), 1)
                keys.splice(keys.indexOf('keys'), 1)
                return keys
            }
        }
        array[0].map(function (d) {
            return d[on]
        }).forEach(function (b) {
            var value = OrdinalPositionHolder.valueOf()
            OrdinalPositionHolder[b] = OrdinalPositionHolder > -1 ? ++value : 0
        })
        var SegData = OrdinalPositionHolder.keys().map(function () {
            return []
        })

        // draw Line
        array.forEach(function (d) {
            d.forEach(function (b) {
                SegData[OrdinalPositionHolder[b[on]]].push(b)
            })
        })
        return SegData
    }

    console.warn('format', format)
    axios.post(url, filterParam).then(response => {
        let Data = response.data
        // Adding salesman in Line Category
        Data.forEach(function (d) {
            d.metric.forEach(function (b) {
                b.dim1 = d.dim1
            })
        })

        // Extension method declaration
        var dim2 = []
        dim2.pro
        var LineCategories = []
        LineCategories.pro

        var x1Scale = d3.scaleBand().rangeRound([0, chart.width]).paddingInner(.2)
        var x2Scale = d3.scaleBand()
        var y1Scale = d3.scaleLinear().range([chart.height, 0])

        var y2Scale = d3.scaleLinear().range([chart.height, 0])
            .domain(d3.extent(Data, function (d) {
                return d3.max(d.metric, function (b) {
                    return b.Value
                })
            }))
        var metric1ColorScale = d3.scaleOrdinal().range(fw_progressive_1way)

        var line = d3.line()
            .x((d) => {
                return x1Scale(d.dim1) + x1Scale.bandwidth() / 2
            })
            .y((d) => {
                return y2Scale(d.Value)
            })

        var x1AxisLabel = d3.axisBottom().scale(x1Scale)
        var y1AxisLabel = d3.axisLeft().scale(y1Scale).tickFormat(inrFormatter)
        var y2AxisLabel = d3.axisRight().scale(y2Scale).tickFormat(inrFormatter)

        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId)
            .append('svg')
            .attr('width', chart.width + chart.margin.left + 2 * chart.margin.right)
            .attr('height', chart.height + 4 * chart.margin.top + chart.margin.bottom)
            .call(responsivefy)
            .append('g')
            .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

        // Bar Data categories
        Data.forEach(function (d) {
            d.dim2.forEach(function (b) {
                if (dim2.findIndex(function (c) {
                    return c.Name === b.Name
                }) === -1) {
                    b.Type = 'bar'
                    dim2.push(b)
                }
            })
        })

        // Line Data dim2
        Data.forEach(function (d) {
            d.metric.forEach(function (b) {
                if (LineCategories.findIndex(function (c) {
                    return c.Name === b.Name
                }) === -1) {
                    b.Type = 'line'
                    LineCategories.push(b)
                }
            })
        })

        // Processing Line data
        let lineData;
        lineData = DataSegregator(Data.map(function (d) {
            return d.metric
        }), 'Name')

        // Line Coloring
        let metric2ColorScale = d3.scaleOrdinal()
        metric2ColorScale.domain(LineCategories.filter(function (d) {
            return d.Type === 'line'
        })
            .map(function (d) {
                return d.Name
            }))

        metric2ColorScale.range(fw_progressive_3way)

        x1Scale.domain(Data.map(function (d) {
            return d.dim1
        }))
        x1Scale.domain(Data.map(function (d) {
            return d.dim1
        }))
        x2Scale.domain(dim2.filter(function (d) {
            return d.Type === 'bar'
        })
            .map(function (d) {
                return d.Name
            }))
            .rangeRound([0, x1Scale.bandwidth()])

        y1Scale.domain([0, d3.max(Data, function (d) {
            return d3.max(d.dim2, function (d) {
                return d.Value
            })
        })])

        svg.append('g')
            .attr('class', 'x axis')
            .attr('transform', 'translate(0,' + chart.height + ')')
            .call(x1AxisLabel)
            .selectAll('text')
            .style('font-size', axisLabelFontSize)
            .style('text-anchor', 'start')
            .attr('dx', XaxisAttribute)
            .attr('dy', '-0.55em')
            .attr('transform', 'rotate(-50)')
            .text(axisTextDim1)

        svg.append('g')
            .attr('class', 'y axis')
            .call(y1AxisLabel)
            .selectAll('text')
            .style('font-size', axisLabelFontSize)

        svg.append('g')
            .attr('class', 'y axis')
            .attr('transform', 'translate(' + (chart.width) + ',0)')
            .call(y2AxisLabel)
            .selectAll('text')
            .style('font-size', axisLabelFontSize)

        svg.append('text')
            .attr('x', (chart.width / 2) - 120)
            .attr('y', chart.height + chart.margin.bottom + 16 * chart.axisLabelDistance)
            .style('fill', fontColor)
            .text(chart.x1AxisDisplayName)
            .style('font-size', fontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('x', 0 - (chart.height / 2))
            .attr('y', 0 - chart.margin.left)
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', fontColor)
            .text(chart.y1AxisDisplayName)
            .style('font-size', fontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('x', 0 - (chart.height / 2))
            .attr('y', chart.width + chart.margin.right + 2 * chart.axisLabelDistance)
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', fontColor)
            .text(chart.y2AxisDisplayName)
            .style('font-size', fontSize)


        if (gridflag == true) {
            // add the X gridlines
            /* svg.append("g")
                             .attr("class", "grid")
                             .attr("transform", "translate(0," + chart.height + ")")
                             .call(make_x_gridlines(x1Scale)
                                .tickSize(-chart.height)
                                .tickFormat("") )*/

            // add the Y gridlines
            svg.append("g")
                .attr("class", "grid")
                .call(make_y_gridlines(y1Scale)
                    .tickSize(-chart.width)
                    .tickFormat(""))
        }

        /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element
                           var y1tip = tooltip_class()

                           y1tip.attr('class', 'd3-tip'+divId.id)
                               .html(function (d) {
                                   return d.Name.replace(/(\d{4})/g, '$1-').trim()+ colonAnnotation+ numberFormat(d.Value)
                               })
                           svg.call(y1tip)*/

        d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
        var div = d3.select(divId).append('div').attr('class', 'tooltip')
            .attr('style', 'position: absolute; opacity: 0;')

        var state = svg.selectAll('.state')
            .data(Data)
            .enter().append('g')
            .attr('class', 'state')
            .attr('transform', (d) => {
                return 'translate(' + x1Scale(d.dim1) + ',0)'
            })

        state.selectAll('rect')
            .data((d) => {
                return d.dim2
            })
            .enter().append('rect')
            .attr('width', x2Scale.bandwidth())
            .attr('x', (d) => {
                return x2Scale(d.Name)
            })
            .attr('y', (d) => {
                return y1Scale(d.Value)
            })
            .style('fill', (d) => {
                return metric1ColorScale(d.Name)
            })
            //.on('mouseover', y1tip.show)
            //.on('mouseout', y1tip.hide)
            //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding
            .on("mousemove", function (d) {
                console.log(d3.event, d)
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html(d.Name.replace(/(\d{4})/g, '$1-').trim() + colonAnnotation + numberFormat(d.Value))
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
            })
            .on("mouseout", function () {
                div.transition().style("opacity", 0)
            })
            .transition().delay(200)
            .attrTween('height', function (d) {
                var i = d3.interpolate(0, chart.height - y1Scale(d.Value))
                return function (t) {
                    return i(t)
                }
            })

        // drawaing lines
        svg.selectAll('.lines')
            .data(lineData)
            .enter()
            .append('g')
            .attr('class', 'line')
            .each(function (d) {
                let Name;
                Name = d[0].Name
                d3.select(this)
                    .append('path')
                    .attr('d', function (b) {
                        return line(b)
                    })
                    .style('stroke-width', '3px')
                    .style('fill', 'none')
                    .style('stroke', metric2ColorScale(Name))
                    .transition()
                    .duration(1500)
            })

        svg.selectAll("dot")
            .data(Data, function (d) {
                return d.metric
            })
            .enter()
            .append("circle")
            .attr("r", 5)
            .attr("cx", function (d) {
                return x1Scale(d.dim1) + x1Scale.bandwidth() / 2
            })
            .attr("cy", function (d) {
                return y2Scale(d.metric[0].Value);
            })
            .style("fill", function (d) {
                return metric2ColorScale(d.metric[0].Name)
            })
            //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
            .on("mouseover", function (d) {
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html(chart.x1MetricTooltip + colonAnnotation + d.dim1 + "<br/>" +
                    d.metric[0].Name + colonAnnotation + numberFormat(d.metric[0].Value))
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
            })
            .on("mouseout", function () {
                div.transition().duration(500).style("opacity", 0);
            });

        console.log("cumlative bar", Data)
        // Legend for bars
        var y1legend = svg.append('g')
            .selectAll('g')
            .data(dim2.map((d) => {
                return {'Name': d.Name, 'Type': d.Type}
            }))
            .enter()
            .append('g')
            .attr('transform', (d, i) => 'translate(0,' + i * 40 + ')')

        y1legend.append('rect')
            .attr('x', 20)
            .attr('y', chart.height + chart.margin.bottom - 20)
            .attr('width', 20)
            .attr('height', 20)
            .style('fill', function (d) {
                return metric1ColorScale(d.Name)
            })

        y1legend.append('text')
            .data(dim2.map(function (d) {
                return {'Name': d.Name}
            }))
            .attr('x', 60)
            .attr('y', chart.height + chart.margin.bottom - 15)
            .attr('dy', '0.62em')
            .style('font-size', axisLabelFontSize)
            .text(function (d) {
                return d.Name.replace(/(\d{4})/g, '$1-').trim()
            })

        // Legend for lines
        var y2legend = svg.append('g')
            .selectAll('g')
            .data(LineCategories.map((d) => {
                return {'Name': d.Name, 'Type': d.Type}
            }))
            .enter()
            .append('g')
            .attr('transform', (d, i) => 'translate(0,' + i * 40 + ')')

        y2legend.append('rect')
            .attr('x', chart.width - (2 * chart.margin.left + chart.margin.right) - 100)
            .attr('y', chart.height + chart.margin.bottom - 20)
            .attr('width', 20)
            .attr('height', 20)
            .style('fill', (d) => {
                return metric2ColorScale(d.Name)
            })

        y2legend.append('text')
            .data(LineCategories.map((d) => {
                return {'Name': d.Name}
            }))
            .attr('x', chart.width - (2 * chart.margin.left + chart.margin.right + 55))
            .attr('y', chart.height + chart.margin.bottom - 15)
            .attr('dy', '0.62em')
            .style('font-size', axisLabelFontSize)
            .text(function (d) {
                return d.Name
            })
    })
}
